import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useEventHub } from '@pwc/event-hub-ui';
import { SimpleModal } from '@pwc/pwc-deals-ui';
import { useDispatch, useSelector } from 'react-redux';
import { changeUserLanguageThunk } from 'common/redux/userSettings/userSettingsThunk';
import { getUserSettingsSelector } from 'common/redux/userSettings/userSettingsSlice';
import styles from './Language.module.scss';
import LanguageFilter from './LanguageFilter';
import languageList from './languageList';

const LanguageSelectionModal = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedLanguageState, setSelectedLanguageState] = useState(1);
  const [languageText, setLanguageText] = useState(languageList[0]);
  const userSettings = useSelector(getUserSettingsSelector);
  const dispatch = useDispatch();
  const { eventHub } = useEventHub();
  const { i18n } = useTranslation();

  const setLanguageState = (projectState: number) => {
    setSelectedLanguageState(projectState);
    setLanguageText(languageList[projectState - 1]);
  };

  useEffect(() => {
    const { settings } = userSettings;
    if (Object.keys(settings).length > 1) {
      const { defaultLanguage } = userSettings.settings;
      if (
        defaultLanguage === null ||
        defaultLanguage === undefined ||
        defaultLanguage.length < 2
      ) {
        setShowModal(true);
      } else {
        setShowModal(false);
      }
    }
  }, [userSettings, userSettings.settings]);

  const onSubmit = () => {
    setShowModal(false);
    dispatch(changeUserLanguageThunk(languageText.value));
    i18n.changeLanguage(languageText.value).catch((err) => {
      // eslint-disable-next-line no-console
      console.log(err);
    });
    eventHub?.publish('change-language', { lng: languageText.value });
    eventHub?.setCurrentLang(languageText.value);
  };

  return (
    <>
      <SimpleModal
        show={showModal}
        header={languageText.headerText}
        submitText={languageText.buttonText}
        closeText="Close"
        onSubmit={() => onSubmit()}
        icon={undefined}
        className={styles.languageSelection}
        onClose={() => setShowModal(false)}
      >
        <div>
          <p className={styles.bodyText}>{languageText.bodyText}</p>
          <LanguageFilter
            items={languageList}
            selectedItemId={selectedLanguageState}
            selectItem={setLanguageState}
          />
        </div>
      </SimpleModal>
    </>
  );
};

export default LanguageSelectionModal;
